// GA4 listing_created payload (GROWTH-8103). See docs/testing/inventories/homeActions.md (homeActions-006 to 011).

// The message Apiv2\Model\Listing\Create\Save::_execute answers with when it hands back the member's existing empty
// draft instead of creating a listing. Nothing new was created, so no listing_created is sent.
export const REUSED_DRAFT_MESSAGE = "Existing empty draft reused.";

// api-v2 resource name (resolveListingApiName) -> listing_type. Anything else went through the profile route.
const LISTING_TYPES = {
  events: "event",
  jobs: "job",
  organizations: "organization"
};

/**
 * The page a listing was created from as a route pattern: no scheme, host, query or hash, and every numeric path
 * segment (a listing id) replaced by ":id", so "/my-events/39053?page=1" and "/my-events/39054" both report
 * "/my-events/:id".
 */
export const listingCreatePagePattern = page => {
  const path = String(page || "")
    .replace(/^[a-z][a-z0-9+.-]*:\/\/[^/?#]*/i, "")
    .split(/[?#]/)[0]
    .replace(/\/+$/, "");

  const pattern = path
    .split("/")
    .map(segment => (/^\d+$/.test(segment) ? ":id" : segment))
    .join("/");

  return pattern || "/";
};

/**
 * listing_created parameters from what the create already has: the api-v2 resource it posted to, the listing row the
 * server returned, the directory list /members/json-api/index/lists loaded for the same modal, and the profession the
 * member picked. A directory that cannot be found is left out rather than sent empty. Heritage is not sent: at
 * creation it is "All Communities" or empty for every listing type that gets here.
 */
export const buildListingCreatedParams = ({ listingName, listing, directories, profession, createPage }) => {
  const directory = (Array.isArray(directories) ? directories : []).find(item => String(item.listings_dir_id) === String(listing?.dir_id));

  return {
    listing_type: LISTING_TYPES[listingName] || "profile",
    ...(directory?.name ? { directory: directory.name } : {}),
    profession,
    listing_create_page: listingCreatePagePattern(createPage)
  };
};
